/* eslint-disable no-console */
const actionTypes = require('constants/actionTypes');
const Api = require('../services/api');
const apiURLBuilder = require('../core/apiURLBuilder');
import { formatText, getLanguage } from 'core/i18n';
const { getReferenceCodeByCountry } = require('utilities/multiLanguageHelper');

const formatOutput = function (output, table) {
    const key = `${table}-${output.languageKey}`;
    const str = formatText(key);
    const value = {
        value: output.id,
        label: str.charAt(0).concat(str.slice(1).toLowerCase()),
        name: str.charAt(0).concat(str.slice(1).toLowerCase()),
        position: output.position,
    };
    if (Object.prototype.hasOwnProperty.call(output, 'europeanUnion')) {
        value.europeanUnion = output.europeanUnion;
    }

    return value;
};

const formatFioc = function (output, text) {
    const key = `${text}-${output.languageKey}`;
    const value = {
        id: output.id,
        description: formatText(key),
    };

    return value;
};

const getIbanBankEntities = function () {
    return dispatch => {
        Api.get(apiURLBuilder.getURL('getIbanBankEintities')).then(response => {
            if (response.body) {
                const data = response.body;
                dispatch({
                    type: actionTypes.ADD_IBANBANKENTITIES,
                    data,
                });
            }
        });
    };
};

function sortByName(a, b) {
    return a.name.localeCompare(b.name);
}

function fieldSorter(fields) {
    return function (a, b) {
        return fields
            .map(function (o) {
                let dir = 1;
                if (o[0] === '-') {
                    dir = -1;
                    o = o.substring(1);
                }
                if (a[o] > b[o]) return dir;
                if (a[o] < b[o]) return -dir;

                return 0;
            })
            .reduce(function firstNonZeroValue(p, n) {
                return p ? p : n;
            }, 0);
    };
}

const getAddresses = function () {
    return dispatch => {
        dispatch({ type: actionTypes.LOAD_ADDRESSES, payload: true });
        const language = getReferenceCodeByCountry();
        const promises = [
            Api.get(apiURLBuilder.getURL('getCountries', { language })),
            Api.get(apiURLBuilder.getURL('getProvinces')),
            Api.get(apiURLBuilder.getURL('getRoadtypes')),
        ];

        Promise.all(promises)
            .then(([countriesResponse, provincesResponse, roadsResponse]) => {
                const groupRoadsArray = roadsResponse.body;

                const countries =
                    countriesResponse.body.sort(sortByName).map(country => {
                        const value = formatOutput(country, 'country');

                        return value;
                    }) || [];
                const provinces =
                    provincesResponse.body.sort(sortByName).map(province => {
                        const value = formatOutput(province, 'province');

                        return value;
                    }) || [];
                const roadsTraducidos =
                    groupRoadsArray.map(road => {
                        const value = formatOutput(road, 'roadType');

                        return value;
                    }) || [];
                const roads = roadsTraducidos.sort(fieldSorter(['position', 'name']));
                dispatch({
                    type: actionTypes.ADD_CITIES,
                    data: provinces,
                });

                dispatch({
                    type: actionTypes.ADD_COUNTRIES,
                    data: countries,
                });

                dispatch({
                    type: actionTypes.ADD_TYPES_OF_ROADS,
                    data: roads,
                });

                dispatch({
                    type: actionTypes.LOAD_ADDRESSES,
                    payload: false,
                });
            })
            .catch(error => {
                //TODO: Manejar el error en el Reducer y Componente respectivos, actualmente el action no
                //      esta siendo recibido en ningun reducer. No hay VD sobre como deberian presentarse
                //      los errores en el componente.
                dispatch({
                    type: actionTypes.LOAD_ADDRESSES,
                    payload: false,
                });

                dispatch({
                    type: actionTypes.LOAD_ADDRESSES_ERROR,
                    payload: error,
                });
            });
    };
};

const getCountries = function () {
    const language = getReferenceCodeByCountry();

    return dispatch => {
        return Api.get(apiURLBuilder.getURL('getCountries', { language })).then(response => {
            const data =
                response.body.map(country => {
                    const value = formatOutput(country, 'country');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.ADD_COUNTRIES,
                data,
            });
        });
    };
};

const getProvinces = function () {
    return dispatch => {
        Api.get(apiURLBuilder.getURL('getProvinces')).then(response => {
            const data =
                response.body.map(province => {
                    const value = formatOutput(province, 'province');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.ADD_CITIES,
                data,
            });
        });
    };
};

const getTypesOfRoads = function () {
    return dispatch => {
        Api.get(apiURLBuilder.getURL('getRoadtypes')).then(response => {
            const data =
                response.body.sort(fieldSorter(['position', 'name'])).map(road => {
                    const value = formatOutput(road, 'roadType');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.ADD_TYPES_OF_ROADS,
                data,
            });
        });
    };
};

const getCategoriesService = (dispatch, type) => {
    if (type === 'cnae') {
        Api.get(apiURLBuilder.getURL('getProfessionCategoriesCNAE')).then(response => {
            const data =
                response.body.items.map(category => {
                    const value = formatFioc(category, 'webSharedFiocCnaeCategory');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.GET_PROFESSION_CATEGORIES_CNAE,
                data,
            });
        });
    }

    if (type === 'cno') {
        Api.get(apiURLBuilder.getURL('getProfessionCategoriesCNO')).then(response => {
            const data =
                response.body.items.map(category => {
                    const value = formatFioc(category, 'webSharedFiocProfession');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.GET_PROFESSION_CATEGORIES_CNO,
                data,
            });
        });
    }
};

const getCategories = (idWorkFor, sector) => {
    const type = idWorkFor === '01' ? 'cnae' : 'cno';

    return function (dispatch) {
        getCategoriesService(dispatch, type, sector);
    };
};

const getProfessionsWorkforService = (dispatch, idWorkFor, sector, byCode) => {
    const url =
        idWorkFor === '01'
            ? apiURLBuilder.getURL('getProfessionCnae')
            : apiURLBuilder.getURL('getProfessionCno', { sector, language: getLanguage() });
    Api.get(url).then(response => {
        if (response.body) {
            if (idWorkFor === '01') {
                const data = response.body.items.map(profession => {
                    const value = formatFioc(profession, 'webSharedFiocCnae');

                    return value;
                });
                if (byCode) {
                    dispatch({
                        type: actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED_CODE,
                        data,
                        idWorkFor,
                    });
                } else {
                    dispatch({
                        type: actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED,
                        data,
                        idWorkFor,
                    });
                }
            }
            if (idWorkFor === '02') {
                const data = response.body.items.map(profession => {
                    const value = formatFioc(profession, 'webSharedFiocCno');

                    return value;
                });
                dispatch({
                    type: actionTypes.ADD_PROFESSIONS_WORK_FOR_EMPLOYED,
                    data,
                    idWorkFor,
                });
            }
        }
    });
};

const getProfessionsWorkfor = (idWorkFor, sector = '', byCode = false) => {
    return function (dispatch) {
        getProfessionsWorkforService(dispatch, idWorkFor, sector, byCode);
    };
};

const getSubCategoriesWorkforService = (dispatch, idWorkFor, subcategory) => {
    const url =
        idWorkFor === '01'
            ? apiURLBuilder.getURL('getProfessionCnaeSubCategory', { subcategory })
            : apiURLBuilder.getURL('getProfessionCnoSubCategory');
    Api.get(url).then(response => {
        if (response.body) {
            if (idWorkFor === '01') {
                const data = response.body.items.map(subcategory => {
                    const value = formatFioc(subcategory, 'webSharedFiocCnae');

                    return value;
                });
                dispatch({
                    type: actionTypes.ADD_PROFESSIONS_WORK_FOR_SELFEMPLOYED__SUBCATEGORIES,
                    data,
                    idWorkFor,
                });
            }

            if (idWorkFor === '02') {
                const data = response.body.items.map(subcategory => {
                    const value = formatFioc(subcategory, 'webSharedFiocProfession');

                    return value;
                });
                dispatch({
                    type: actionTypes.ADD_PROFESSIONS_WORK_FOR_EMPLOYED_SUBCATEGORIES,
                    data,
                    idWorkFor,
                });
            }
        }
    });
};

const getSubCategoriesWorkfor = (idWorkFor, category) => {
    return function (dispatch) {
        getSubCategoriesWorkforService(dispatch, idWorkFor, category);
    };
};

const getWorkForService = dispatch => {
    Api.get(apiURLBuilder.getURL('getWorkfor')).then(response => {
        if (response.body) {
            const data = response.body.map(workFor => {
                const value = formatFioc(workFor, 'webSharedFiocWorkFor');

                return value;
            });
            dispatch({
                type: actionTypes.ADD_WORK_FOR,
                data,
            });
        }
    });
};

const getWorkFor = () => {
    return dispatch => {
        getWorkForService(dispatch);
    };
};

const showFullHomeAddress = () => {
    return {
        type: actionTypes.SHOW_FULL_HOME_ADDRESS,
    };
};

const showFullPostalAddress = () => {
    return {
        type: actionTypes.SHOW_FULL_POSTAL_ADDRESS,
    };
};

const getServerDateService = dispatch => {
    Api.get(apiURLBuilder.getURL('getServerDate')).then(response => {
        if (response.body) {
            const date = response.body.date;
            dispatch({
                type: actionTypes.SERVER_DATE,
                date,
            });
        }
    });
};

const getServerDate = () => {
    return dispatch => {
        getServerDateService(dispatch);
    };
};

const setServerDate = date => {
    return dispatch => {
        dispatch({
            type: actionTypes.SERVER_DATE,
            date,
        });
    };
};

const clearProfessionsWorkList = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_PROFESSION_LIST,
        });
    };
};

const clearSubcategoriesList = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_CATEGORIES_LIST,
        });
    };
};

const clearSubcategoriesProfessionsWorkList = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_SUBCATEGORIES_PROFESSION_LIST,
        });
    };
};

const getProfessionSectorCategoriesService = dispatch => {
    Api.get(apiURLBuilder.getURL('professionSectorsCategories')).then(response => {
        if (response.body) {
            const data =
                response.body.items.map(category => {
                    const value = formatFioc(category, 'webSharedFiocSectorCategory');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.GET_PROFESSION_SECTOR_CATEGORIES,
                data,
            });
        }
    });
};

const getProfessionSectorService = (dispatch, idCategory) => {
    Api.get(apiURLBuilder.getURL('professionSectors', { idCategory })).then(response => {
        if (response.body) {
            const data =
                response.body.items.map(sector => {
                    const value = formatFioc(sector, 'webSharedFiocSector');

                    return value;
                }) || [];
            dispatch({
                type: actionTypes.GET_PROFESSION_SECTOR,
                data,
            });
        }
    });
};

const setLoadAresService = (dispatch, state) => {
    dispatch({
        type: actionTypes.LOAD_ARES,
        payload: state,
    });
};

const getProfessioSectorCategories = () => {
    return dispatch => {
        getProfessionSectorCategoriesService(dispatch);
    };
};

const clearProfessionSector = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_PROFESSION_SECTOR,
        });
    };
};

const getProfessionSector = idCategory => {
    return dispatch => {
        getProfessionSectorService(dispatch, idCategory);
    };
};

const setLoadAres = state => {
    return dispatch => {
        setLoadAresService(dispatch, state);
    };
};

const isCountrySelectedFromEuropeanUnion = () => (dispatch, getState) => {
    const countries = getState().options.get('countries').toJS();
    const selectedCountryWithData = countries.find(country => country.value === getState().userProfile.nationality);

    return selectedCountryWithData?.europeanUnion;
};

export default {
    getIbanBankEntities,
    getCountries,
    getProvinces,
    getTypesOfRoads,
    getAddresses,
    getWorkFor,
    showFullHomeAddress,
    showFullPostalAddress,
    getProfessionsWorkfor,
    getServerDate,
    setServerDate,
    clearProfessionsWorkList,
    getCategories,
    getSubCategoriesWorkfor,
    clearSubcategoriesProfessionsWorkList,
    clearSubcategoriesList,
    getProfessioSectorCategories,
    getProfessionSector,
    clearProfessionSector,
    setLoadAres,
    isCountrySelectedFromEuropeanUnion,
};
